module.exports = __webpack_public_path__ + "static/media/radiolac.2c2d346b.png";